import React from "react";
import DataGridPartenaire from "./datagrid/DataGridPartenaire";

const Partenaire = () => {
  return (
    <div>
      <DataGridPartenaire />
    </div>
  );
};

export default Partenaire;
